export function HorizontalDivider({ dividerText, style }) {
  return (
    <section id="horizontal-divider" style={style}>
      {dividerText}
      <div className="dividerLine"></div>
    </section>
  );
}
